import type { aiOrg as en } from "../en/aiOrg";
import type { Messages } from "../types";

/** ALP-86: نشاط الذكاء الاصطناعي لكل مؤسسة ومستخدم + نماذج المؤسسة (مفاتيح العميل والتوجيه لكل استخدام). */
export const aiOrg: Messages<typeof en> = {
  page: {
    back: "المؤسسات",
    backUsers: "المستخدمون",
    title: "الذكاء الاصطناعي",
    userTitle: "نشاط الذكاء الاصطناعي",
    platformTitle: "نشاط الذكاء الاصطناعي",
    platformHint: "كل استدعاءات الذكاء الاصطناعي لكل المؤسسات من Langfuse. افتح مؤسسة أو مستخدمًا لعرضه الخاص.",
    tabs: { activity: "نشاط الذكاء الاصطناعي", models: "نماذج الذكاء الاصطناعي" },
  },
  links: {
    org: "نشاط ونماذج الذكاء الاصطناعي",
    orgHint: "التتبّع والاستهلاك ومفاتيح العميل والتوجيه",
    userActivity: "نشاط الذكاء الاصطناعي",
  },
  activity: {
    title: "نشاط الذكاء الاصطناعي",
    description: "كل استدعاء ذكاء اصطناعي ضمن هذا النطاق كما تتبّعه Langfuse: الميزة والنموذج والرموز والتكلفة وزمن الاستجابة والخطوات.",
    range: "الفترة",
    ranges: { "24h": "24 ساعة", "7d": "7 أيام", "30d": "30 يومًا" },
    feature: "الميزة",
    allFeatures: "كل الميزات",
    model: "النموذج",
    allModels: "كل النماذج",
    status: "الحالة",
    statuses: { all: "الكل", ok: "ناجحة", error: "أخطاء" },
    member: "العضو",
    allMembers: "كل الأعضاء",
    org: "المؤسسة",
    allOrgs: "كل المؤسسات",
    stats: { calls: "استدعاءات النماذج", tokens: "الرموز", cost: "التكلفة", errors: "الأخطاء" },
    perDay: "الاستدعاءات والتكلفة يوميًا",
    calls: "الاستدعاءات",
    cost: "التكلفة",
    byFeature: "حسب الميزة",
    byModel: "حسب النموذج",
    traces: "سجلات التتبّع",
    automation: "أتمتة",
    unknownUser: "مستخدم غير معروف",
    byok: "مفتاح العميل",
    steps_zero: "بلا خطوات",
    steps_one: "خطوة واحدة",
    steps_two: "خطوتان",
    steps_few: "{{count}} خطوات",
    steps_many: "{{count}} خطوة",
    steps_other: "{{count}} خطوة",
    empty: "لا توجد استدعاءات ذكاء اصطناعي في هذه الفترة",
    emptyHint: "جرّب فترة أطول أو امسح عوامل التصفية.",
    disabledTitle: "لا يمكن قراءة تتبّع الذكاء الاصطناعي هنا",
    disabledHint: "اضبط LANGFUSE_URL وLANGFUSE_PUBLIC_KEY وLANGFUSE_SECRET_KEY على الواجهة الخلفية لرؤية سجلات التتبّع. تبقى المفاتيح على الخادم.",
    openLangfuse: "فتح في Langfuse",
    col: { feature: "الميزة", user: "المستخدم", model: "النموذج", tokens: "الرموز", cost: "التكلفة", latency: "زمن الاستجابة", status: "الحالة", when: "الوقت" },
  },
  trace: {
    title: "سجل التتبّع",
    totals: "الإجمالي",
    steps: "الخطوات",
    input: "المدخلات",
    output: "المخرجات",
    metadata: "البيانات الوصفية",
    statusMessage: "رسالة الحالة",
    noSteps: "لم تُسجَّل أي خطوات",
    scrubbed: "تُحذف الأسرار والرموز وأسماء المزوّدين قبل العرض.",
    latency: "زمن الاستجابة",
    tokens: "الرموز",
    cost: "التكلفة",
    model: "النموذج",
    session: "الجلسة",
  },
  models: {
    title: "نماذج الذكاء الاصطناعي",
    description: "مفاتيح المزوّد الخاصة بالعميل (BYOK) والنموذج الذي يخدم كل استخدام لهذه المؤسسة.",
    unavailable: {
      feature_off: "مفاتيح العميل غير مفعّلة لهذه المؤسسة",
      feature_offHint: "فعّل ميزة الخطة «استخدام مفتاح ذكاء اصطناعي خاص» باستثناء من صفحة الخطة والاستحقاقات.",
      openPlan: "فتح الخطة والاستحقاقات",
      no_gateway_db: "غير متاح في هذه البيئة",
      no_gateway_dbHint: "بوابة الذكاء الاصطناعي هنا بلا قاعدة بيانات (يحتاج LiteLLM قاعدة بيانات مع STORE_MODEL_IN_DB)، لذا لا يمكن إنشاء نماذج خاصة بالمؤسسة.",
      gateway_unreachable: "تعذّر الوصول إلى بوابة الذكاء الاصطناعي",
      gateway_unreachableHint: "يمكن تعديل الاتصالات والتوجيه عند عودة البوابة.",
    },
    connections: "اتصالات المزوّدين",
    connectionsHint: "المفاتيح مشفّرة عند التخزين ولا يظهر منها إلا تلميح مقنّع.",
    add: "إضافة اتصال",
    noConnections: "لا توجد اتصالات بعد",
    noConnectionsHint: "أضف مفتاح العميل لتوجيه استخداماته إلى نماذجه.",
    providers: { openai: "OpenAI", anthropic: "Anthropic", azure_openai: "Azure OpenAI", openai_compatible: "متوافق مع OpenAI" },
    providerHints: {
      openai: "api.openai.com بمفتاح العميل",
      anthropic: "نماذج Claude بمفتاح العميل",
      azure_openai: "مورد Azure الخاص بالعميل ونشراته",
      openai_compatible: "أي عنوان أساسي متوافق مع OpenAI",
    },
    status: { untested: "لم يُختبر", ok: "يعمل", error: "متعطّل" },
    modelStatus: { ready: "جاهز", error: "خطأ" },
    defaultHost: "افتراضي المزوّد",
    key: "المفتاح",
    lastTest: "آخر اختبار {{when}}",
    neverTested: "لم يُختبر قط",
    test: "اختبار",
    testOk: "الاتصال يعمل ({{ms}} مللي ثانية)",
    testFailed: "فشل الاتصال",
    rotate: "تدوير المفتاح",
    edit: "تعديل",
    delete: "حذف",
    actionsFor: "إجراءات {{name}}",
    form: {
      addTitle: "إضافة اتصال مزوّد",
      addDescription: "يُرسَل مفتاح العميل إلى بوابة الذكاء الاصطناعي كنماذج خاصة بالمؤسسة؛ ولا يمكن لأي مؤسسة أخرى استخدامها.",
      editTitle: "تعديل الاتصال",
      provider: "المزوّد",
      name: "الاسم",
      namePlaceholder: "مثال: OpenAI الخاص بالعميل",
      apiKey: "مفتاح API",
      apiKeyHint: "للكتابة فقط: يُخزَّن مشفّرًا ولا يُعرض مرة أخرى.",
      apiBase: "العنوان الأساسي",
      apiBaseHint: "مطلوب لـ Azure OpenAI والمزوّدين المتوافقين مع OpenAI.",
      apiVersion: "إصدار API",
      models: "النماذج",
      modelId: "معرّف النموذج",
      modelIdHint: "كما يسمّيه المزوّد (في Azure: اسم النشر).",
      label: "التسمية",
      kind: "النوع",
      kinds: { chat: "محادثة", embedding: "تضمينات", image: "صور" },
      priceIn: "$ / مليون رمز مدخل",
      priceOut: "$ / مليون رمز مخرج",
      addModel: "إضافة نموذج",
      removeModel: "إزالة النموذج {{n}}",
      reason: "السبب",
      reasonHint: "يُسجَّل في سجل التدقيق مع التغيير.",
      create: "إضافة الاتصال",
      save: "حفظ",
      created: "أُضيف الاتصال",
      saved: "حُفظ الاتصال",
      invalid: "املأ المزوّد والاسم والمفتاح والنماذج وسببًا (3 أحرف على الأقل).",
      baseRequired: "العنوان الأساسي مطلوب لهذا المزوّد.",
    },
    rotateTitle: "تدوير مفتاح {{name}}",
    rotateBody: "يحلّ المفتاح الجديد محل القديم في البوابة فورًا.",
    newKey: "مفتاح API الجديد",
    rotated: "دُوِّر المفتاح",
    deleteTitle: "حذف {{name}}؟",
    deleteBody: "تُزال نماذجه من البوابة ويعود كل استخدام موجَّه إليها إلى نموذج المنصّة.",
    deleted: "حُذف الاتصال",
    routing: "التوجيه لكل استخدام",
    routingHint: "يعمل كل استخدام على نموذج المنصّة أو على أحد نماذج هذه المؤسسة.",
    useCase: "الاستخدام",
    servedBy: "النموذج",
    platformDefault: "افتراضي المنصّة ({{name}})",
    locked: "المنصّة فقط",
    lockedHint: {
      copilot: "يعمل المساعد كمسار محادثة في Dify على نموذج المنصّة؛ ولا يستطيع Dify تغيير النموذج أو المفتاح لكل مؤسسة.",
      embed: "يتم تضمين البحث بالمعنى داخل Dify Knowledge بنموذج المنصّة.",
    },
    useCases: {
      classify: "تصنيف التعليقات",
      reply_draft: "مسودات الردود",
      caption: "التعليقات النصية وتقييم المنشور",
      copilot: "المساعد",
      image: "الصور",
      embed: "التضمينات",
      agents: "وكلاء الذكاء الاصطناعي",
    },
    saveRoutes: "حفظ التوجيه",
    routesTitle: "حفظ التوجيه",
    routesBody: "تستخدم استدعاءات الذكاء الاصطناعي الجديدة لهذه المؤسسة النماذج المختارة.",
    routesSaved: "حُفظ التوجيه",
    changes_zero: "بلا تغييرات",
    changes_one: "تغيير واحد",
    changes_two: "تغييران",
    changes_few: "{{count}} تغييرات",
    changes_many: "{{count}} تغييراً",
    changes_other: "{{count}} تغيير",
    spend: "الإنفاق هذا الشهر",
    spendHint: "الإنفاق على مفاتيح العميل لا يُحتسب من ميزانية الذكاء الاصطناعي في ملفك.",
    malfakSpend: "ميزانية ملفك للذكاء الاصطناعي",
    byokSpend: "مفاتيح العميل",
    byokTokens: "رموز مفاتيح العميل",
    keys: "مفاتيح البوابة",
    mainScoped: "مفتاح ملفك مقصور على نماذج المنصّة",
    mainUnscoped: "مفتاح ملفك غير مقصور بعد على نماذج المنصّة",
    byokKey: "مفتاح نماذج العميل",
    noByokKey: "يُنشأ مع أول اتصال",
  },
};
